import * as React from "react";
import ReferidosContainer from "../containers/referidos-container";

export default function ContactoPage() {
  return <ReferidosContainer></ReferidosContainer>;
}
